import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export function pdfFilename(invoice, prefix = '') {
  const name = (invoice.customerName || 'Walk-in')
    .replace(/[^\w\u0600-\u06FF\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  return `${name}-${prefix}${invoice.invoiceNumber}.pdf`;
}

export async function downloadElementAsPdf(el, filename, orientation = 'portrait') {
  const pageW = orientation === 'landscape' ? 1020 : 720;
  const wrap = document.createElement('div');
  wrap.style.cssText = `position:fixed;left:-14000px;top:0;width:${pageW}px;background:#fff;`;
  const clone = el.cloneNode(true);
  clone.style.width = `${pageW}px`;
  clone.style.maxWidth = `${pageW}px`;
  wrap.appendChild(clone);
  document.body.appendChild(wrap);
  try {
    const canvas = await html2canvas(clone, { scale: 2, useCORS: true, backgroundColor: '#ffffff', width: pageW, windowWidth: pageW });
    const pdf = new jsPDF({ unit: 'pt', format: 'a4', orientation });
    const pw = pdf.internal.pageSize.getWidth();
    const ph = pdf.internal.pageSize.getHeight();
    const margin = 24;
    const w = pw - margin * 2;
    const pxPerPt = canvas.width / w;
    const pageBodyPx = (ph - margin * 2) * pxPerPt;

    // Safe break points: bottom edge of every row / block, in canvas pixels.
    const cssToCanvas = canvas.width / pageW;
    const top = clone.getBoundingClientRect().top;
    const breaks = Array.from(clone.querySelectorAll('tr, [data-pdf-block]'))
      .map((n) => (n.getBoundingClientRect().bottom - top) * cssToCanvas)
      .filter((b) => b > 0)
      .sort((a, b) => a - b);

    let y = 0;
    let firstPage = true;
    while (y < canvas.height - 1) {
      let end = Math.min(y + pageBodyPx, canvas.height);
      if (end < canvas.height) {
        // never cut through a row: fall back to the last row boundary that fits
        const fits = breaks.filter((b) => b > y + pageBodyPx * 0.2 && b <= end);
        if (fits.length) end = fits[fits.length - 1];
      }
      const sliceH = Math.max(1, Math.round(end - y));
      const slice = document.createElement('canvas');
      slice.width = canvas.width;
      slice.height = sliceH;
      const ctx = slice.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, slice.width, slice.height);
      ctx.drawImage(canvas, 0, Math.round(y), canvas.width, sliceH, 0, 0, canvas.width, sliceH);
      if (!firstPage) pdf.addPage();
      pdf.addImage(slice.toDataURL('image/jpeg', 0.9), 'JPEG', margin, margin, w, sliceH / pxPerPt);
      firstPage = false;
      y = end;
    }
    pdf.save(filename);
  } finally {
    document.body.removeChild(wrap);
  }
}
